<template>
	<div>
		<h2>1. Datenschutz auf einen Blick</h2>
		<h3>Allgemein</h3>
		<p>
			Wir nehmen den Schutz Ihrer personenbezogenen Daten ernst und beachten die
			Regeln der anwendbaren Datenschutzgesetze. Wir unterliegen den
			Datenschutzbestimmungen der Diözese Rottenburg-Stuttgart, insbesondere dem
			Gesetz über den Kirchlichen Datenschutz (KDG), der Durchführungsverordnung
			zum Gesetz über den Kirchlichen Datenschutz (KDG-DVO) und den weiteren zur
			Durchführung des KDG ergangenen Vorschriften. Wir sind sorgfältig bemüht,
			das Datengeheimnis möglichst umfassend zu wahren. Diese
			Datenschutzerklärung gilt für diesen Internetauftritt und für die über
			diesen erhobenen personenbezogenen Daten. Für Internetseiten anderer
			Anbieter, auf die z.B. über Links verwiesen wird, gelten die dortigen
			Datenschutzhinweise und -erklärungen. Es ist uns wichtig, dass Sie
			jederzeit wissen, welche personenbezogenen Daten während Ihres Besuchs auf
			unserer Webseite und bei Nutzung unserer Angebote erhoben werden und wie
			wir sie verwenden.
		</p>
		<h3>Umfang, Verarbeitung und Weitergabe personenbezogener Daten</h3>
		<p>
			Nachfolgend informieren wir Sie über die Erhebung personenbezogener Daten
			bei der Nutzung unserer Internetseite.
		</p>
		<p>
			Der Begriff „personenbezogene Daten“ meint unter Verweis auf die
			Definition des § 4 Nr. 1 KDG alle Daten, die auf Sie persönlich beziehbar
			sind. Darunter fallen beispielsweise Name, Adresse, E-Mail-Adresse,
			Nutzerverhalten. Hinsichtlich weiterer Begrifflichkeiten, insbesondere der
			Begriffe „Verarbeitung“, „Verantwortlicher“, „Auftragsverarbeiter“ und
			„Einwilligung“, verweisen wir auf die gesetzlichen datenschutzrechtlichen
			Definitionen des § 4 KDG.
		</p>
		<p>
			Wir verarbeiten personenbezogene Daten grundsätzlich nur, soweit dies zur
			Bereitstellung einer funktionsfähigen Webseite sowie der von uns
			angebotenen Inhalte und Leistungen erforderlich ist. Die Erhebung,
			Verarbeitung und Verwendung personenbezogener Daten unserer Nutzerinnen
			und Nutzer erfolgt jedenfalls nur in den vom geltenden Datenschutzrecht
			gezogenen Grenzen, eine Verarbeitung und Weitergabe personenbezogener
			Daten zu kommerziellen Zwecken oder für professionelle Adress-Sammlungen
			erfolgt unsererseits nicht. Eine Adressdatenweitergabe ohne Ihre
			Einwilligung erfolgt nur in Fällen, in denen eine vorherige Einholung
			einer Einwilligung aus tatsächlichen Gründen nicht möglich ist oder die
			Verarbeitung und Weitergabe der Daten durch gesetzliche Vorschriften
			gestattet ist.
		</p>
		<p>
			Die Nutzung unserer Website ist grundsätzlich ohne Angabe
			personenbezogener Daten möglich. Sollten auf ihr personenbezogene Daten
			(beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden,
			erfolgt dies, soweit möglich, auf freiwilliger Basis und im Interesse der
			wissenschaftlichen Kommunikation.
		</p>
		<h3>Rechtsgrundlagen für die Verarbeitung personenbezogener Daten</h3>
		<p>
			Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine
			Einwilligung der betroffenen Person einholen, dient § 6 Abs. 1 lit. b KDG
			als Rechtsgrundlage für die Verarbeitung personenbezogener Daten. Bei der
			Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines
			Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich
			ist, dient § 6 Abs. 1 lit. c KDG als Rechtsgrundlage. Dies gilt auch für
			Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen
			erforderlich sind. Soweit eine Verarbeitung und Weitergabe
			personenbezogener Daten zur Erfüllung rechtlicher Verpflichtungen
			erforderlich ist, denen wir unterliegen, bildet § 6 Abs. 1 lit. d KDG die
			Rechtsgrundlage hierfür. Für den Fall, dass lebenswichtige Interessen der
			betroffenen Person oder einer anderen natürlichen Person eine Verarbeitung
			personenbezogener Daten erforderlich machen, bildet § 6 Abs. 1 lit. e KDG
			die Rechtsgrundlage.
		</p>
		<h3>Datenlöschung und Speicherdauer</h3>
		<p>
			Die personenbezogenen Daten von Nutzerinnen und Nutzern unseres
			Internetauftritts und der Datenbank werden gelöscht oder gesperrt, sobald
			der Zweck der Speicherung entfällt. Eine Speicherung kann insbesondere
			dann erfolgen, wenn dies durch den kirchlichen, europäischen oder
			nationalen Gesetzgeber in kirchlichen, staatlichen oder unionsrechtlichen
			Rechtsnormen, denen wir unterliegen, vorgesehen ist. Aus ihnen ergibt sich
			dann auch die Speicherdauer, die wir einzuhalten haben. Eine Sperrung oder
			Löschung der Daten erfolgt dann, wenn eine durch die genannten Normen
			vorgeschriebene Speicherfrist abläuft. Soweit Sie in eine längere
			Speicherdauer ausdrücklich eingewilligt haben oder über unseren
			Internetauftritt vertragliche Absprachen erfolgen, die eine längere
			Speicherung von Daten vorsehen oder ermöglichen, ist dies für die Dauer
			der Datenspeicherung ausschlaggebend.
		</p>
		<p>
			Soweit wir für einzelne Funktionen unserer Webseite auf beauftragte
			Dienstleister zurückgreifen oder Ihre Daten für werbliche Zwecke nutzen
			möchten, werden wir Sie untenstehend im Detail über die jeweiligen
			Vorgänge informieren.
		</p>
		<h3>Verantwortliche Stelle</h3>
		<p>
			Den Verantwortlichen im Sinne des § 4 Nr. 9 KDG, der sonstigen in den
			Mitgliedstaaten der Europäischen Union geltenden Datenschutzgesetze und
			anderer Vorschriften sowie Bestimmungen mit datenschutzrechtlichem
			Charakter entnehmen Sie bitte dem Impressum dieser Webseite.
		</p>
		<h2>2. Hosting</h2>
		<h3>IONOS</h3>
		<p>
			Wir hosten unsere Website bei IONOS SE. Anbieter ist die IONOS SE,
			Elgendorfer Str. 57, 56410 Montabaur (nachfolgend: IONOS). Wenn Sie unsere
			Website besuchen, erfasst IONOS verschiedene Logfiles inklusive Ihrer
			IP-Adressen. Details entnehmen Sie der Datenschutzerklärung von IONOS:
			<br />
			<a href="https://www.ionos.de/terms-gtc/terms-privacy">
				https://www.ionos.de/terms-gtc/terms-privacy
			</a>
			.
		</p>
		<p>
			Die Verwendung von IONOS erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
			KDG. Wir haben ein berechtigtes Interesse an einer möglichst zuverlässigen
			Darstellung unserer Website. Sofern eine entsprechende Einwilligung
			abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von
			Art. 6 Abs. 1 lit. a KDG; die Einwilligung ist jederzeit widerrufbar.
		</p>
		<h3>Auftragsverarbeitung</h3>
		<p>
			Wir haben einen Vertrag über Auftragsverarbeitung (AVV) mit dem oben
			genannten Anbieter geschlossen. Hierbei handelt es sich um einen
			datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass
			dieser die personenbezogenen Daten unserer Websitebesucher nur nach
			unseren Weisungen und unter Einhaltung der KDG verarbeitet.
		</p>
		<h2>3. Datenschutzbeauftragter</h2>
		<h3>Gesetzlich vorgeschriebener Datenschutzbeauftragter</h3>
		<p>
			Bischöfliches Ordinariat
			<br />
			Stabsstelle Datenschutz
			<br />
			Postfach 9 | 72101 Rottenburg
			<br />
			Fon 07472 169 -890
			<br />
			Fax 07472 169 -838 90
			<br />
			<a href="mailto:datenschutz@bo.drs.de">datenschutz@bo.drs.de</a>
		</p>
		<p>
			Weiterhin unterliegen wir der Datenschutzaufsicht des katholischen
			Datenschutzzentrums Frankfurt/M. Sie können sich an diese Stelle wenden,
			wenn Sie Datenschutzverstöße unsererseits geltend machen oder sich in
			anderer Hinsicht über unser Datenschutzverhalten beschweren wollen. Die
			Kontaktdaten des Katholischen Datenschutzzentrums Franfurt/M. lauten
			folgendermaßen:
		</p>
		<h3>Kontaktdaten der Datenschutzaufsicht</h3>
		<p>
			Katholisches Datenschutzzentrum Frankfurt a.M.
			<br />
			Haus am Dom
			<br />
			Domplatz 3
			<br />
			60311 Frankfurt
			<br />
			Fon 069 800 871 -88 00
			<br />
			Fax 069 800 871 -88 15
			<br />
			<a href="mailto:info@kdsz-ffm.de">info@kdsz-ffm.de</a>
			<br />
			<a href="www.kdsz-ffm.de">www.kdsz-ffm.de</a>
		</p>
		<h2>4. Ihre Rechte</h2>
		<p>
			Sie haben uns gegenüber hinsichtlich der Sie betreffenden
			personenbezogenen Daten die nachfolgenden Rechte:
		</p>
		<ul class="standard-list">
			<li>Das Recht auf Widerruf von Einwilligungserklärungen § 8 KDG,</li>
			<li>das Recht auf Auskunft § 17 KDG,</li>
			<li>das Recht auf Berichtigung und Löschung §§ 18, 19 KDG,</li>
			<li>das Recht auf Einschränkung der Verarbeitung § 20 KDG,</li>
			<li>das Recht auf Unterrichtung der verarbeitenden Stellen § 21 KDG,</li>
			<li>das Recht auf Datenübertragbarkeit § 22 KDG,</li>
			<li>das Recht auf Widerspruch gegen die Verarbeitung § 23 KDG</li>
		</ul>
		<p>
			Ihre Rechte wollen Sie bitte ggf. unter der im Impressum genannten Adresse
			geltend machen.
		</p>
		<p>
			Wenn Sie beim Recht auf Widerspruch (§ 23 KDG) Gebrauch machen, müssen wir
			Sie allerdings bitten, Internetauftritt und Datenbank künftig nicht mehr
			zu nutzen, da bei jedem Auftritt Nutzerdaten automatisiert erhoben und
			gespeichert werden und ggf. aus rechtlichen Gründen gespeichert werden
			müssen.
		</p>
		<p>
			Sie haben zusätzlich das Recht, sich bei einer
			Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen
			Daten durch uns zu beschweren und Verstöße zu melden § 48 KDG.
		</p>
		<h2>5. Datenerfassung auf unserer Website</h2>
		<h3>
			Verarbeitung personenbezogener Daten bei informatorischer Nutzung unserer
			Webseite
		</h3>
		<p>
			Wenn Sie unsere Webseite aufrufen, ohne sich dabei zu registrieren oder
			uns auf andere Weise Informationen zukommen zu lassen („Informatorische
			Nutzung“) erheben wir nur diejenigen personenbezogenen Daten, die Ihr
			Webbrowser an unseren Server übermittelt. Wenn Sie unsere Webseite
			betrachten möchten, erheben wir die folgenden Daten, die für uns technisch
			erforderlich sind, um Ihnen die Anzeige unserer Webseite zu ermöglichen
			und die Stabilität und Sicherheit zu gewährleisten:
		</p>
		<ul class="standard-list">
			<li>IP-Adresse</li>
			<li>Datum und Uhrzeit der Anfrage</li>
			<li>Zeitzonendifferenz zu GMT</li>
			<li>Inhalt der Webseite</li>
			<li>Zugriffsstatus (HTTP-Status)</li>
			<li>übertragene Datenmenge</li>
			<li>Website, von der Sie auf unsere Website gelangt sind</li>
			<li>Webbrowser</li>
			<li>Betriebssystem</li>
			<li>Sprache und Version des Browsers</li>
		</ul>
		<p>
			Die vorgenannten Daten werden ebenfalls in sog. Logfiles auf unseren
			Servern gespeichert. Nicht hiervon betroffen sind Ihre IP-Adresse oder
			andere Daten, die eine Zuordnung der Daten zu Ihnen ermöglichen. Eine
			Speicherung dieser Daten zusammen mit anderen personenbezogenen Daten von
			Ihnen findet nicht statt.
		</p>
		<p>
			Die Erhebung und vorübergehende Speicherung der IP-Adresse ist notwendig,
			um die Auslieferung unserer Webseite auf Ihr Endgerät zu ermöglichen.
			Hierfür muss Ihre IP-Adresse für die Dauer des Besuchs unserer Webseite
			gespeichert werden. Die Speicherung der oben genannten Daten in Logfiles
			dient der Sicherstellung der Funktionsfähigkeit und zur Optimierung
			unserer Webseite sowie zur Sicherstellung der Sicherheit unserer
			informationstechnischen Systeme. Eine Auswertung dieser Daten zu
			Marketingzwecken findet nicht statt.
		</p>
		<p>
			In den vorstehenden Zwecken liegt unser berechtigtes Interesse an der
			Datenverarbeitung. Rechtsgrundlage für die Erhebung und die vorübergehende
			Speicherung der vorgenannten Daten ist § 6 Abs. 1 lit. g KDG. Die
			vorstehenden Daten zur Bereitstellung unserer Website werden gelöscht,
			wenn die jeweilige Sitzung beendet ist. Eine Löschung der Daten in
			Logfiles findet spätestens nach dreißig Tagen statt. Eine
			darüberhinausgehende Speicherung nehmen wir nur vor, wenn wir zuvor Ihre
			IP-Adresse gelöscht oder verfremdet haben und so eine Zuordnung der Daten
			zu Ihrer Person nicht mehr möglich ist. Die Erhebung der vorstehenden
			Daten zur Bereitstellung unserer Webseite und die Speicherung dieser Daten
			in Logfiles ist für den Betrieb unserer Website zwingend erforderlich. Es
			besteht keine Widerspruchsmöglichkeit.
		</p>
		<h3>SSL- bzw. TLS-Verschlüsselung</h3>
		<p>
			Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
			vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die
			Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung.
			Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile
			des Browsers von „http://“ auf „https://“ wechselt und an dem
			Schloss-Symbol in Ihrer Browserzeile. Wenn die SSL- bzw.
			TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns
			übermitteln, nicht von Dritten mitgelesen werden.
		</p>
		<h3>
			Verarbeitung personenbezogener Daten durch Cookies (Wenn Cookies gesetzt
			werden)
		</h3>
		<p>
			Wir verwenden auf unserer Webseite sog. Cookies. Bei Cookies handelt es
			sich um kleine Textdateien, die auf dem Speichermedium Ihres Endgerätes,
			also beispielsweise auf einer Festplatte, gespeichert werden und durch die
			uns als Stelle, die den Cookie setzt, bestimmte Informationen zufließen.
			Cookies können keine Programme ausführen oder Viren auf Ihr Endgerät
			übertragen. Diese Webseite verwendet folgende Arten von Cookies, deren
			Umfang und Funktionsweise nachfolgend erläutert werden. Cookies, die Ihrem
			Webbrowser zugehörig gespeichert werden
		</p>
		<p>
			<b>Persistente Cookies:</b>
			Diese Cookies werden automatisiert nach einer vorgegebenen Dauer gelöscht,
			die sich je nach Cookie unterscheiden kann. Diese Cookies können Sie in
			den Einstellungen Ihres Webbrowsers jederzeit löschen
		</p>
		<p>
			Die Verarbeitung personenbezogener Daten durch die vorstehenden Cookies
			dient dazu, das Angebot unserer Webseite insgesamt für Sie
			nutzerfreundlicher und effektiver zu machen. Einige Funktionen unserer
			Webseite können ohne den Einsatz dieser Cookies nicht angeboten werden.
			Insbesondere erfordern einige Funktionen unserer Webseite es, dass Ihr
			Webbrowser auch noch nach einem Seitenwechsel identifiziert werden kann.
			Diejenigen Daten, die durch Cookies verarbeitet werden, die für die
			Bereitstellung der Funktionen unserer Webseite erforderlich sind, werden
			nicht zur Erstellung von Nutzerprofilen verwendet. Soweit Cookies zu
			Analysezwecken eingesetzt werden, dienen diese dazu, die Qualität und
			Nutzerfreundlichkeit unserer Webseite, ihrer Inhalte und Funktionen zu
			verbessern. Sie ermöglichen uns, nachzuvollziehen, wie die Webseite,
			welche Funktionen und wie oft diese genutzt werden. Dies ermöglicht uns,
			unser Angebot fortlaufend zu optimieren.
		</p>
		<p>
			In den vorstehenden Zwecken liegt unser berechtigtes Interesse an der
			Datenverarbeitung. Rechtsgrundlage ist § 6 Abs. 1 lit. g KDG.
		</p>
		<p>
			Die vorstehenden Cookies werden auf Ihrem Endgerät gespeichert und von
			diesem an unseren Server übermittelt. Sie können daher die Verarbeitung
			der Daten und Informationen durch Cookies selbst konfigurieren. Sie können
			in den Einstellungen Ihres Webbrowsers entsprechende Konfigurationen
			vornehmen, durch die Sie beispielsweise Third-Party-Cookies oder Cookies
			insgesamt ablehnen können. In diesem Zusammenhang möchten wir Sie darauf
			hinweisen, dass Sie dann eventuell nicht alle Funktionen unserer Webseite
			ordnungsgemäß nutzen können. Darüber hinaus empfehlen wir eine regelmäßige
			manuelle Löschung von Cookies sowie Ihres Browser-Verlaufs.
		</p>
		<h2>6. Kontaktaufnahme</h2>
		<p>
			Wenn Sie mit uns per E-Mail Kontakt aufnehmen, werden die von Ihnen an uns
			mit Ihrer E-Mail übermittelten personenbezogenen Daten gespeichert.
		</p>
		<p>
			Die Daten werden ausschließlich zur Beantwortung Ihrer Fragen verwendet.
			Soweit dies nicht explizit in dieser Datenschutzerklärung angegeben ist,
			erfolgt keine Weitergabe der Daten an Dritte. Zusätzlich erfassen wir Ihre
			IP-Adresse und den Zeitpunkt der Absendung.
		</p>
		<p>
			Die Verarbeitung der vorstehenden personenbezogenen Daten dient allein zur
			Bearbeitung Ihrer Anfragen.
		</p>
		<p>
			Hierin liegt auch unser berechtigtes Interesse an der Verarbeitung Ihrer
			personenbezogenen Daten. Soweit Sie uns hierfür eine Einwilligung erteilt
			haben, ist Rechtsgrundlage für die Verarbeitung dieser Daten § 6 Abs. I
			lit. b KDG. Im Übrigen ist Rechtsgrundlage für die Verarbeitung dieser
			Daten § 6 Abs. I lit. g KDG, insbesondere für den Fall, dass uns die Daten
			von Ihnen durch Übersendung einer E-Mail übermittelt werden. Soweit Sie
			durch Ihre E-Mail auf den Abschluss eines Vertrages hinwirken wollen,
			stellt § 6 Abs. I lit. c KDG eine zusätzliche Rechtsgrundlage dar.
		</p>
		<p>
			Die Daten werden vorbehaltlich gesetzlicher Aufbewahrungsfristen gelöscht,
			sobald wir Ihre Anfrage abschließend bearbeitet haben. Bei einer
			Kontaktaufnahme per E-Mail können Sie der Speicherung Ihrer
			personenbezogenen Daten jederzeit widersprechen. Wir weisen Sie darauf
			hin, dass in diesem Fall Ihre Anfrage nicht weiterbearbeitet werden kann.
			Den Widerruf oder den Widerspruch können Sie durch Übersendung einer
			E-Mail an unsere im Impressum angegebene E-Mail-Adresse erklären.
		</p>
		<h2>7. Plugins und Tools</h2>
		<h3>YouTube</h3>
		<p>
			Unsere Website nutzt Plugins der von Google betriebenen Seite YouTube.
			Betreiber der Seiten ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA
			94066, USA.
		</p>
		<p>
			Wenn Sie eine unserer mit einem YouTube-Plugin ausgestatteten Seiten
			besuchen, wird eine Verbindung zu den Servern von YouTube hergestellt.
			Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie
			besucht haben.
		</p>
		<p>
			Wenn Sie in Ihrem YouTube-Account eingeloggt sind, ermöglichen Sie
			YouTube, Ihr Surfverhalten direkt Ihrem persönlichen Profil zuzuordnen.
			Dies können Sie verhindern, indem Sie sich aus Ihrem YouTube-Account
			ausloggen.
		</p>
		<p>
			Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden
			Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes
			Interesse im Sinne von §6 Abs. I lit. g KDG dar.
		</p>
		<p>
			Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der
			Datenschutzerklärung von YouTube unter:
			<br />
			<a href="https://www.google.de/intl/de/policies/privacy">
				https://www.google.de/intl/de/policies/privacy
			</a>
			.
		</p>
		<h3>Google Maps</h3>
		<p>
			Diese Seite nutzt über eine API den Kartendienst Google Maps. Anbieter ist
			die Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.
		</p>
		<p>
			Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP
			Adresse zu speichern. Diese Informationen werden in der Regel an einen
			Server von Google in den USA übertragen und dort gespeichert. Der Anbieter
			dieser Seite hat keinen Einfluss auf diese Datenübertragung.
		</p>
		<p>
			Die Nutzung von Google Maps erfolgt im Interesse einer ansprechenden
			Darstellung unserer Online-Angebote und an einer leichten Auffindbarkeit
			der von uns auf der Website angegebenen Orte. Dies stellt ein berechtigtes
			Interesse im Sinne von § 6 Abs. I lit. g KDG dar.
		</p>
		<p>
			Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der
			Datenschutzerklärung von Google:
			<br />
			<a href="https://www.google.de/intl/de/policies/privacy/">
				https://www.google.de/intl/de/policies/privacy/
			</a>
			.
		</p>
		<h2>8. Übersicht verwendete Cookies</h2>
		<ul class="standard-list">
			<li>Benutzerauthentifizierung</li>
		</ul>
	</div>
</template>
